var utils = require('./sv-jedesheim.utils.js');
var validator = require('./sv-jedesheim.validator.js');

function initializeElements() {

	if (location.hash !== '') {
		if ($('.nav[role="tablist"]').length) {
			$('.nav[role="tablist"] a[href="' + '#tab_' + location.hash.substr(1) + '"]').tab('show');
		}
	} else {
		if ($('.nav[role="tablist"]').length) {
			$('.nav[role="tablist"] a:first').tab('show');
			window.location.hash = $('.nav[role="tablist"] a:first')[0].hash.replace('tab_', '');
		}
	}

	$('.c-paginate-list').easyPaginate({
		paginateElement: '.c-content-blog-post-1',
		elementsPerPage: 2,
		hashPage: '',
		firstButton : false,
		lastButton: false
	});

	$('#tab_panel_section').tabCollapse({
		tabsClass: 'hidden-sm hidden-xs',
		accordionClass: 'visible-sm visible-xs',
		updateLinks: true
	});

	// listen for events
	window.addEventListener("load", callbackFunc);
	window.addEventListener("resize", callbackFunc);
	window.addEventListener("scroll", callbackFunc);

	utils.setDateFormat();

	$.each($('.select2:not(.select2-container)'), function() {
		var tags = false;
		var tokenSeparators = [];
		if ($(this).data().tags == true)
		{
			tags = true;
			tokenSeparators = [',', ' '];
		}

		$(this).select2({
			tags: tags,
			tokenSeparators: tokenSeparators
		});

		$(this).addClass("select2-container");
	});

	$('.c-mosaic').cubeportfolio({
		layoutMode: 'mosaic'
	})

	$('.c-cubeportfolio').cubeportfolio({
		filters: '#filters-container',
		loadMore: '#loadMore-container',
		loadMoreAction: 'click',
		layoutMode: 'grid',
		defaultFilter: $('[name="default_filter"]').val(),
		animationType: 'quicksand',
		gapHorizontal: 35,
		gapVertical: 25,
		gridAdjustment: 'responsive',
		mediaQueries: [{
			width: 1100,
			cols: 4
		}, {
			width: 800,
			cols: 3
		}, {
			width: 500,
			cols: 2
		}, {
			width: 320,
			cols: 1
		}],
		caption: 'zoom',
		displayType: 'lazyLoading',
		displayTypeSpeed: 100,

		// lightbox
		lightboxDelegate: '.cbp-lightbox',
		lightboxGallery: true,
		lightboxTitleSrc: 'data-title',
		lightboxCounter: '<div class="cbp-popup-lightbox-counter">{{current}} of {{total}}</div>',

		// singlePage popup
		singlePageDelegate: '.cbp-singlePage',
		singlePageDeeplinking: true,
		singlePageStickyNavigation: true,
		singlePageCounter: '<div class="cbp-popup-singlePage-counter">{{current}} of {{total}}</div>',
	});

	initializeDatepicker($('.datepicker:not(.datepicker-container)'));

	validator.setValidationToForms();
}

function isElementInViewport(el) {
	var rect = el.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

function callbackFunc() {
	var items = document.querySelectorAll(".timeline li");
	for (var i = 0; i < items.length; i++) {
		if (isElementInViewport(items[i])) {
			items[i].classList.add("in-view");
		}
	}
}

function initializeDatepicker(elements) {

	elements.each(function () {

		var dataDateFormat = $(this).data('dateformat') || 'full';

		if (dataDateFormat === 'full') {
			dataDateFormat = utils.getLocaleDateFormat();
		}
		dataDateFormat = utils.getMomentFormat(dataDateFormat);
		$(this).mask('?' + utils.getLocaleDateFormatMask(dataDateFormat), { placeholder: '_' });

		$(this).data('format', dataDateFormat);
		var picker = new Pikaday({
			field: $(this)[0],
			format: dataDateFormat,
			firstDay: 1,
			yearRange: 20,
			i18n: {
				previousMonth : trans('sv-jedesheim.previous_month'),
				nextMonth     : trans('sv-jedesheim.next_month'),
				months        : [trans('sv-jedesheim.january'),trans('sv-jedesheim.february'),trans('sv-jedesheim.march'),trans('sv-jedesheim.april'),trans('sv-jedesheim.may'),trans('sv-jedesheim.june'),trans('sv-jedesheim.july'),trans('sv-jedesheim.august'),trans('sv-jedesheim.september'),trans('sv-jedesheim.october'),trans('sv-jedesheim.november'),trans('sv-jedesheim.december')],
				weekdays      : [trans('sv-jedesheim.sunday'),trans('sv-jedesheim.monday'),trans('sv-jedesheim.tuesday'),trans('sv-jedesheim.wednesday'),trans('sv-jedesheim.thursday'),trans('sv-jedesheim.friday'),trans('sv-jedesheim.saturday')],
				weekdaysShort : [trans('sv-jedesheim.sunday_short'),trans('sv-jedesheim.monday_short'),trans('sv-jedesheim.tuesday_short'),trans('sv-jedesheim.wednesday_short'),trans('sv-jedesheim.thursday_short'),trans('sv-jedesheim.friday_short'),trans('sv-jedesheim.saturday_short')]
			},
			onOpen: function (e) {

				if ($(this._o.field).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
					this.setDate(moment().toDate());
					$(this._o.field).val('');
				}
			},
			onSelect: function() {
				if (this.getDate() === null) {
					$(this._o.field).val('');
				} else {
					$(this._o.field).val(moment(this.getDate()).format(dataDateFormat));
				}
			}
		});

		$(this).data('picker', picker);

		var initValue = $(this).data().initValue;
		if (!utils.isUndefined(initValue) && initValue !== '') {
			if (initValue !== 'not_collected' && initValue !== 'unknown' && initValue !== 'continuing') {
				picker.setDate(utils.stringToDate(initValue));
			} else {
				picker.setDate(null);
				$(this).parents('.input').find('input').val(trans('sv-jedesheim.' + initValue));
			}
		} else {
			picker.setDate(null);
		}

		$(this).addClass("datepicker-container");
	});
}

function initializeSlider() {

	var slider = $('.c-layout-revo-slider .tp-banner');

	var cont = $('.c-layout-revo-slider .tp-banner-container');

	var api = slider.show().revolution({
		sliderType:"standard",
		sliderLayout:"fullscreen",
		gridwidth:4064,
		gridheight:720,


		delay: 5000,
		startwidth:1170,
		startheight: App.getViewPort().height,

		navigationType: "hide",
		navigationArrows: "solo",

		touchenabled: "on",

		navigation: {
			keyboardNavigation:"off",
			keyboard_direction: "horizontal",
			mouseScrollNavigation:"off",
			onHoverStop:"on",
			arrows: {
				style:"circle",
				enable:true,
				hide_onmobile:true,
				hide_under: 991,
				hide_onleave:false,
				tmp:'',
				left: {
					h_align:"left",
					v_align:"center",
					h_offset:30,
					v_offset:0
				},
				right: {
					h_align:"right",
					v_align:"center",
					h_offset:30,
					v_offset:0
				}
			}
		},

		spinner: "spinner2",

		shadow: 0,
		disableProgressBar:"on",

		hideThumbsOnMobile: "on",
		hideNavDelayOnMobile: 1500,
		hideBulletsOnMobile: "on",
		hideArrowsOnMobile: "on",
		hideThumbsUnderResolution: 0
	});
}

module.exports.initializeSlider = initializeSlider;
module.exports.initializeElements = initializeElements;
